function createAction(type, argNames = [], defaults) {
  function actionCreator(...args) {
    const payload = argNames.reduce((acc, item, index) => {
      acc[item] = args[index]
      return acc
    }, {})
    return {
      type,
      ...defaults,
      ...payload,
    }
  }
  // override toString so we can use actionCreators as keys to our reducer
  actionCreator.toString = () => type
  return actionCreator
}

// for tests
// This is needed because the compair object comes in with ObjectSchema and Entity types, but the action does not
export const handleCompareSchema = (schema) =>
  JSON.parse(JSON.stringify(schema))

export { createAction }
